import React from "react";
import { faqs } from "../mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-[#0a101e]">
      <div className="max-w-3xl mx-auto px-5">
        <div className="text-center mb-14">
          <div className="inline-block bg-yellow-400/10 border border-yellow-400/30 rounded-full px-4 py-1.5 mb-5">
            <span className="text-xs tracking-widest text-yellow-400 font-semibold">
              HOW IT WORKS & FAQ
            </span>
          </div>
          <p className="text-slate-400 text-lg">
            Everything you need to know about purchasing, paying with crypto, and receiving your keys instantly.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-[#0f1a30] border border-yellow-400/20 rounded-xl px-5 data-[state=open]:border-yellow-400/50 transition-colors"
            >
              <AccordionTrigger className="text-left text-slate-100 hover:no-underline hover:text-yellow-400 py-5 text-base [&>svg]:text-yellow-400">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-300 text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
